@let showMedia = push?.media;
@let showRichParagraph = ((!hasNoData && !!push?.richParagraph?.heading?.data)  || push?.richParagraph?.links?.length || push?.richParagraph?.linksImages?.length);

@if (showRichParagraph) {
  <sd-rich-paragraph
    [brand]="brand"
    [indexFollow]="indexFollow"
    [isLoading]="isLoading"
    [contentData]="push?.richParagraph"
    (noData)="checkData($event)"
    [isDescription]="isDescription"
    #content
    class="{{push?.media?.isVideo && !mediaAsBackground ? 'is-relative' : ''}}"
    [hideButtonLink]="hideButtonLink"
    (click)="onClickCardFrame(push)"
    (clicked)="onClick($event)"
    [hasReadMore]="hasReadMore"
    [textConfig]="textConfig"
    [parentsThemesConfig]="themesConfig"
    [titleLevel]="titleLevel"
    [subtitleLevel]="subtitleLevel"
    [size]="contentSize"
  />
}
@if (brandBar && showMedia && showRichParagraph) {
  <sd-brand-bar
    [brand]="brandBar"
    [isVerticalBar]="!isMobile$ && (mediaConfig === positionEnum.left || mediaConfig === positionEnum.right)"
  />
}
@if (showMedia) {
  <sd-banner
    [isComponentLoading]="isLoading"
    class="is-main {{hasNoData || (hasNoData && (push?.richParagraph?.links?.length || push?.richParagraph?.linksImages?.length)) ? 'has-no-overlay' : ''}}"
    #banner
    [isFit]="isFit"
    (mediaPlay)="onVideoPlayed()"
    (mediaEnded)="onVideoEnded()"
    [isAriaHidden]="true"
    [imgRatio]="imageRatio"
    [hasModal]="!mediaAsBackground && hasModal"
    [media]="push.media"
    [videoTitle]="push?.richParagraph?.heading?.data?.title"
    [hasAltText]="false"
    [twicPicsAutoSize]="twicPicsAutoSize"
  />
}
